/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { compose } from 'redux';
import {
    object,
}
from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ImageCard from './ImageCard';

const styles = (theme) => {
    const {
        palette,
        breakpoints: {
            maxWidth,
        },
    } = theme;
    return {
        InstructionNoteWrapper: {
            '&.instruction-note': {
                marginBottom: '40px',
                '& .align-content-xl-around': {
                    [theme.breakpoints.up(maxWidth.big_screen_down)]: {
                        alignContent: 'space-around !important',
                    },
                },
                '& .mb-0': {
                    marginBottom: '0px !important',
                },
                '& .pl-3': {
                    paddingLeft: '1rem !important',
                },
                '& .h6': {
                    fontSize: '1rem',
                    fontWeight: 700,
                },
                '& .text-center': {
                    textAlign: 'center !important',
                },
                '& .inote-container': {
                    display: 'table',
                    width: '100%',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        display: 'block',
                    },
                    '&>div': {
                        display: 'table-cell',
                        width: '25%',
                        [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                            display: 'block',
                            width: '100%',
                            borderBottom: `1px solid ${palette.common.gray}`,
                            borderRight: '0 !important',
                            '&:first-child': {
                                borderTop: `1px solid ${palette.common.gray}`,
                            },
                        },
                    },
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        background: palette.common.white,
                        paddingLeft: '10px !important',
                        paddingRight: '10px !important',
                        '& >.image-wrapper': {
                            [theme.breakpoints.down(maxWidth.xs_screen)]: {
                                borderRight: '0',
                            },
                        },
                    },
                    '&>.image-wrapper': {
                        borderRight: `1px solid ${palette.common.gray}`,
                        '&:last-child': {
                            borderRight: 'none',
                        },
                    },
                },
                '& .image-card': {
                    maxWidth: '200px',
                    margin: '0px auto',
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        '& .h6': {
                            fontSize: '13px',
                        },
                        '& > div': {
                            borderRight: '0',
                        },
                        maxWidth: '100%',
                        margin: '0px auto',
                        display: 'flex',
                        alignItems: 'center',
                        '& p': {
                            marginBottom: '0px',
                            marginLeft: '5px',
                            fontSize: `${'13px'} !important`,
                        },
                    },
                    '& .image-card-inner': {
                        display: 'inline-block',
                        [theme.breakpoints.down(maxWidth.medium_screen_up)]: {
                            width: '30px',
                        },
                    },
                    '& .image-card-inner-redesign': {
                        display: 'inline-block',
                        maxHeight: '30px',
                        [theme.breakpoints.down(maxWidth.medium_screen_up)]: {
                            width: '30px',
                        },
                    },
                    '& a': {
                        textDecoration: 'none',
                    },
                    '& .h6': {
                        display: 'inline-block',
                        [theme.breakpoints.down(maxWidth.medium_screen_up)]: {
                            fontSize: '0.875rem',
                            lineHeight: '16px',
                        },
                        [theme.breakpoints.down(maxWidth.xs_screen)]: {
                            fontSize: '13px',
                        },
                    },
                    '& p': {
                        fontSize: '18px',
                        wordBreak: 'normal',
                        marginBottom: '10px',
                        marginTop: '0px',
                        [theme.breakpoints.down(maxWidth.medium_screen_up)]: {
                            fontSize: '0.875rem',
                            lineHeight: '16px',
                            marginBottom: '0',
                        },
                        [theme.breakpoints.down(maxWidth.xs_screen)]: {
                            fontSize: '13px',
                        },
                    },
                },
                '& img, svg': {
                    maxWidth: '52px',
                    maxHeight: '52px',
                    margin: '20px 0',
                    verticalAlign: 'middle',
                    [theme.breakpoints.down(maxWidth.medium_screen_up)]: {
                        maxWidth: '45px',
                        maxHeight: '45px',
                        margin: '10px 0',
                    },
                    [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                        maxWidth: '30px',
                        maxHeight: '30px',
                        margin: '5px 0 5px 0',
                    },
                },
                [theme.breakpoints.up('768')]: {
                    marginLeft: '0',
                    marginRight: '0',
                    '& .col': {
                        maxWidth: '25%',
                    },
                },
                [theme.breakpoints.down('768')]: {
                    '& .col': {
                        minWidth: '50%',
                    },
                },
            },
            [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                '&.instruction-note': {
                    margin: '0',
                },
            },
        },
    };
};

const ProductInstructions = (props) => {
    const { classes, pageData: { product: { productSkus } } } = props;
    const { attributes } = productSkus[0];
    const instructionData = [
        {
            id: 'care_tips_light',
            label: 'Sunlight',
            description: '',
            img_url: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltea871d062b25d11c/63764c502f1aba10d25a9ebd/sunlight2x.png',
            width: 52,
            height: 52,
        },
        {
            id: 'care_tips_water',
            label: 'Water',
            description: '',
            img_url: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt581f2e758981e960/63764c7097ed2210a4d5358a/water2x.png',
            width: 38,
            height: 52,
        },
        {
            id: 'care_tips_temperature',
            label: 'Temperature',
            description: '',
            img_url: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blta853aea987a64280/63764c8e0d85671097f17714/temperature2x.png',
            width: 19,
            height: 52,
        },
        {
            id: 'care_tips_friendliness',
            label: 'Pet Friendly',
            description: '',
            img_url: 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt2c34308c56bf728b/63764ca614868d10af0dd023/petfriendly2x.png',
            width: 41,
            height: 52,
        },
    ];

    attributes.map((item) => {
        instructionData.map((care, index) => {
            if (care.id === item.name) {
                instructionData[index].description = item.values[0].value;
            }
            return item;
        });
        return item;
    });

    return (
        <div className={`instruction-note ${classes.InstructionNoteWrapper}`}>
            <div className="inote-container align-content-xl-around">
                {typeof instructionData !== 'undefined' ? instructionData.map((item) => (
                    item.description ? (
                        <div id={item.label.replace(/ +/g, '').toLowerCase()} key={item.label} className="text-center image-wrapper pl-sm-1 pr-sm-1 align-content-xl-around">
                            {item && <ImageCard imageCard={item} />}
                        </div>
                    ) : null
                ),
                ) : null}
            </div>
        </div>
    );
};

ProductInstructions.propTypes = {
    pageData: object.isRequired,
    classes: object.isRequired,
};

export default compose(withStyles(styles))(ProductInstructions);
